import {
  CREATE_EXTERNAL_ACCOUNT_FAILURE,
  CREATE_EXTERNAL_ACCOUNT_REQUEST,
  CREATE_EXTERNAL_ACCOUNT_SUCCESS,
  DELETE_EXTERNAL_ACCOUNT_FAILURE,
  DELETE_EXTERNAL_ACCOUNT_REQUEST,
  DELETE_EXTERNAL_ACCOUNT_SUCCESS,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_FAILURE,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_REQUEST,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_SUCCESS,
  GET_EXTERNAL_ACCOUNTS_SCHEMA_FAILURE,
  GET_EXTERNAL_ACCOUNTS_SCHEMA_REQUEST,
  GET_EXTERNAL_ACCOUNTS_SCHEMA_SUCCESS,
  GET_EXTERNAL_ACCOUNT_BY_ID_FAILURE,
  GET_EXTERNAL_ACCOUNT_BY_ID_REQUEST,
  GET_EXTERNAL_ACCOUNT_BY_ID_SUCCESS,
  SET_MODAL_TYPE,
  UPDATE_EXTERNAL_ACCOUNT_FAILURE,
  UPDATE_EXTERNAL_ACCOUNT_REQUEST,
  UPDATE_EXTERNAL_ACCOUNT_SUCCESS,
} from 'actionConstants';
import apiClient from 'apiClient';
import { history } from 'store';

import i18n from 'shared/lib/i18n';

import CountdownModalComponent from '../Modal/CountdownModalComponent';

import { CONFIRM, WITH_COUNTDOWN } from '../Modal/modalTypes';

export const loadExternalAccountsSchema = (dispatch) =>
  dispatch({
    type: GET_EXTERNAL_ACCOUNTS_SCHEMA_REQUEST,
    payload: apiClient.systemExternalAccounts.getSchema().then(
      (res) => {
        dispatch({
          type: GET_EXTERNAL_ACCOUNTS_SCHEMA_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_EXTERNAL_ACCOUNTS_SCHEMA_FAILURE,
          err,
        }),
    ),
  });

export const loadExternalAccountsByType = (
  dispatch,
  accountType,
  queryParams,
) =>
  dispatch({
    type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_REQUEST,
    payload: apiClient.systemExternalAccounts
      .getByType(accountType, queryParams)
      .then(
        (res) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_SUCCESS,
            accountType,
            res,
          }),
        (err) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_FAILURE,
            err,
          }),
      ),
  });

export const loadExternalAccountById = (dispatch, accountType, accountId) =>
  dispatch({
    type: GET_EXTERNAL_ACCOUNT_BY_ID_REQUEST,
    payload: apiClient.systemExternalAccounts
      .getById(accountType, accountId)
      .then(
        (res) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNT_BY_ID_SUCCESS,
            accountId,
            res,
          }),
        (err) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNT_BY_ID_FAILURE,
            err,
          }),
      ),
  });

export const createExternalAccount = (dispatch, accountType, data) =>
  dispatch({
    type: CREATE_EXTERNAL_ACCOUNT_REQUEST,
    isForm: true,
    payload: apiClient.systemExternalAccounts
      .createByType(accountType, data)
      .then(
        (res) => {
          dispatch({
            type: CREATE_EXTERNAL_ACCOUNT_SUCCESS,
            res,
          });
          return res;
        },
        (err) => {
          dispatch({
            type: CREATE_EXTERNAL_ACCOUNT_FAILURE,
            err,
          });
          return err;
        },
      ),
  });

export const updateExternalAccount = (dispatch, accountType, accountId, data) =>
  dispatch({
    type: UPDATE_EXTERNAL_ACCOUNT_REQUEST,
    isForm: true,
    payload: apiClient.systemExternalAccounts
      .updateById(accountType, accountId, data)
      .then(
        (res) => {
          dispatch({
            type: UPDATE_EXTERNAL_ACCOUNT_SUCCESS,
            res,
          });
          return res;
        },
        (err) => {
          dispatch({
            type: UPDATE_EXTERNAL_ACCOUNT_FAILURE,
            err,
          });
          return err;
        },
      ),
  });

export const deleteExternalAccount = (dispatch, accountType, accountId) =>
  dispatch({
    type: DELETE_EXTERNAL_ACCOUNT_REQUEST,
    payload: apiClient.systemExternalAccounts
      .deleteById(accountType, accountId)
      .then(
        (res) =>
          dispatch({
            type: DELETE_EXTERNAL_ACCOUNT_SUCCESS,
            res,
          }),
        (err) =>
          dispatch({
            type: DELETE_EXTERNAL_ACCOUNT_FAILURE,
            err,
          }),
      ),
  });

export const confirmToDeleteExternalAccount = (
  dispatch,
  accountType,
  accountId,
  listParams,
) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: async () => {
      await deleteExternalAccount(dispatch, accountType, accountId);
      loadExternalAccountsByType(dispatch, accountType, listParams);
    },
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const confirmExternalPaymentsUrl = (
  dispatch,
  type,
  id,
  data,
  isUpdate,
) => {
  const modalProps = {
    bodyText: i18n.t('externalAccounts.externalPaymentNote'),
    confirmText: i18n.t('actions.confirm'),
    cancelText: i18n.t('actions.edit'),
    countDownTime: 5,
    textToBeReplaced: null,
    onConfirm: async () => {
      const res = isUpdate
        ? await updateExternalAccount(dispatch, type, id, data)
        : await createExternalAccount(dispatch, type, data);
      if (res?.data) history.goBack();
    },
    onCancel: () => {},
    callbackAfterTimeOut: () => window.open(data?.url),
    hideCloseButton: true,
    render: (state, props) => (
      <CountdownModalComponent state={state} props={props} />
    ),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: WITH_COUNTDOWN,
    modalProps,
  });
};
